import axios from "./../../utils/axiosInstance";
import React, { useEffect, useState } from "react";
import { RxDashboard } from "react-icons/rx";
import { FaRegStar } from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import toast from "react-hot-toast";
import "./Dashboard.css";
import Navigation2 from "../../components/navigation/Navigation";
import Navigation from "../../components/navigation/Navigation";

const token = localStorage.getItem("token");

const Dashboard = () => {
  const [boards, setBoards] = useState([]);
  const [isAllBoards, setIsAllBoards] = useState(false);
  const [isStarred, SetIsStarred] = useState(false);
  const handleAllBoards = async () => {
    setIsAllBoards(true);
    SetIsStarred(false);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASED_URL}/board`
      );
      setBoards(response.data.boards);
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
      if (error.response.status !== 200 && error.response.status !== 500)
        window.location.href = "/login";
    }
  };

  const handleStarred = async () => {
    setIsAllBoards(false);
    SetIsStarred(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASED_URL}/board/starred`
      );
      setBoards(response.data.boards);
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
      if (error.response.status !== 200 && error.response.status !== 500)
        window.location.href = "/login";
    }
  };

  const handleStarIcon = async (board) => {
    console.log(board);
    const starred = board.starred;
    const boardId = board._id;
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASED_URL}/board/${boardId}`,
        { starred: !starred }
      );
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
      if (error.response.status !== 200 && error.response.status !== 500)
        window.location.href = "/login";
    }
    if (isAllBoards) handleAllBoards();
    if (isStarred) handleStarred();
  };

  const handleNewBoard = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/board`,
        {
          title: "Type a title...",
        }
      );
      const newBoard = response.data.board;
      localStorage.setItem("board", JSON.stringify(newBoard));
      window.location.href = `/boards?boardId=${newBoard._id}`;
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
      if (error.response.status !== 200 && error.response.status !== 500)
        window.location.href = "/login";
    }
  };

  const handleClickBoard = (board) => {
    console.log(board);
    localStorage.setItem("board", JSON.stringify(board));
    window.location.href = `/boards?boardId=${board._id}`;
  };

  const handleDeleteButton = async (board) => {
    const boardId = board._id;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASED_URL}/board/${boardId}`
      );
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
      if (error.response.status !== 200 && error.response.status !== 500)
        window.location.href = "/login";
    }
    if (isAllBoards) handleAllBoards();
    if (isStarred) handleStarred();
  };

  useEffect(() => {
    handleAllBoards();
  }, []);

  return (
    <div className="flex flex-col">
      {/* <div className="flex flex-row w-screen h-[6vh] border-b-[1px] border-neutral-300"></div> */}
      <Navigation />
      <div className="flex flex-row">
        <div className="flex flex-col h-[94vh] w-[20vw] p-3 gap-3">
          <button
            className={`flex flex-row items-center justify-start rounded-xl px-3 py-2 gap-3 hover:bg-neutral-200 ${
              isAllBoards ? "text-sky-600" : ""
            }`}
            onClick={handleAllBoards}
          >
            <RxDashboard size={"24px"} />
            <text className="font-medium">All boards</text>
          </button>
          <button
            className={`flex flex-row items-center justify-start rounded-xl px-3 py-2 gap-3 hover:bg-neutral-200 ${
              isStarred ? "text-sky-600" : ""
            }`}
            onClick={handleStarred}
          >
            <FaRegStar size={"24px"} />
            <text className="font-medium">Starred</text>
          </button>
        </div>
        <div className="dashboard__bg flex flex-col w-full gap-10 py-5 px-16">
          <div className="flex items-center justify-center">
            <button
              className="flex flex-row gap-3 p-3 items-center justify-center w-[30vw] h-[4vh] rounded-xl bg-indigo-500 hover:bg-indigo-600"
              onClick={handleNewBoard}
            >
              <div className="flex items-center justify-center bg-indigo-400 w-6 h-6 rounded-full">
                <FiPlus size={"20px"} color="white" />
              </div>
              <text className="text-neutral-100 text-lg font-medium">
                New Board
              </text>
            </button>
          </div>
          <div className="flex flex-col gap-3">
            <text className="text-2xl">
              {isAllBoards ? "All Boards" : isStarred ? "Starred Boards" : ""}
            </text>
            {Array.isArray(boards) &&
              boards.map((board, idx) => (
                <div className="flex flex-row gap-3">
                  <button
                    key={idx}
                    className="flex flex-row gap-3 p-3 items-center justify-start w-[50vh] h-[4vh] rounded-xl hover:bg-neutral-200 border-[1px] border-neutral-300"
                    onClick={() => handleClickBoard(board)}
                  >
                    <FaRegStar
                      className={`${
                        board.starred ? "text-pink-600" : "text-neutral-600"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleStarIcon(board);
                      }}
                    />
                    <text className="text-neutral-950">{board.title}</text>
                  </button>
                  <button>
                    <RiDeleteBin6Line
                      className="text-neutral-300 hover:text-neutral-800"
                      onClick={() => handleDeleteButton(board)}
                    />
                  </button>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
